<script>
	import { FormWizard, TabContent } from "vue-form-wizard"
	import "vue2-dropzone/dist/vue2Dropzone.min.css"
	import "vue-form-wizard/dist/vue-form-wizard.min.css"
	import Layout from "../../layouts/main"
	import PageHeader from "@/components/page-header"
	import appConfig from "@/app.config"
	import Multiselect from "vue-multiselect"
	import "vue-multiselect/dist/vue-multiselect.min.css"
	import { required, minLength } from "vuelidate/lib/validators"
	import VueTimepicker from "vue2-timepicker"
	import 'vue2-timepicker/dist/VueTimepicker.css'

	import * as customValidators from '@/utils/validators'

	/**
	 * Form-upload component
	 */
	export default {
		components: {
			Layout,
			PageHeader,
			Multiselect,
			FormWizard,
			TabContent,
			VueTimepicker,
		},
		page: {
			title: "Form File Upload",
			meta: [
				{
					name: "description",
					content: appConfig.description,
				},
			],
		},
		validations: {
			journeyName: {
				required,
				noInvalidStrings: customValidators.noInvalidStrings,
			},
			documentFields: {
				minLength: minLength(1),
				$each: {
					name: {
						required
					},
					isUnique: function(currItem, itemArr) {
						var firstIdx = itemArr.findIndex((item) => currItem.name === item.name)
						if (currItem === itemArr[firstIdx]) {
							return true
						}
						return false
					}
				},
			},
			isOneDocumentSelected: function() {
				return this.documentFields.some(field => field.name)
			}
		},
		data() {
			return {
				title: "Form File Upload",
				items: [
					{
						text: "Forms",
						href: "/",
					},
					{
						text: "Form File Upload",
						active: true,
					},
				],
				pageType: '',
				number: "",
				data: [],
				journeyId: null,
				jobRoles: [],
				journeyName: 'Common Template',
				firstActive: '',
				thirdActive: '',
				enabled: false,
				jobOptions: [
					"All",
					"Sales Manager",
					"Full Stack Developer",
					"Android Developer",
					"iOS Developer",
					"Backend Developer",
					"Accounts Manager",
					"Sales Executive",
					"HR",
				],
				document: null,
				docOptions: [
					"Offer Letter",
					"Pan Card",
					"Aadhaar Card",
					"Driving License"
				],
				day: null,
				dayOptions: [
					"0",
					"1 Day",
					"2 Days",
					"3 Days",
					"7 Days",
					"15 days",
					"30 days",
				],
				trigger: null,
				triggerOptions: [
					"After sending offer letter",
					"After offer acceptance",
					"After document verification",
					"Before Joining",
					"After Joining",
				],
				action: null,
				isJourneyNameExists: false,
				//isOneDocumentSelected: false,
				actionOptions: [
					"Send Material",
					"Collect Information",
					"Collect Feedback",
				],
				rulesFields: [
					{
						id: 1,
						triggerTime: 'hh:mm A',
						isTriggerTimeError: false,
						isMaterialsError: false,
						materials: {
							id: 1,
							materialLink: '',
							materialInputText: '',
						},
						questions: [
							{
								id: 1,
								questionText: '',
								questionError: '',
							},
						],
					},
				],
				faqFields: [
					{
						question: "",
						answer: "",
					},
				],
				documentFields: [
					{
						name: null,
						isVerificationRequired: false,
						isESignRequired: true
					},
				],
				file: '',
				showModal: false,
				onboardJourneyDetail: '',
				isCorporateIdAvailable: false,
				//branches: null,
				corporateId: null,
				branchId: null,
			}
		},
		computed: {
			isOneDocumentSelected: function() {
				return this.documentFields.some(field => field.name)
			},
		},
		mounted: function() {
			this.corporateId = sessionStorage.getItem('corporateId')
			//this.getCorporateBranchList()
			if (this.$route.params.type == 'edit') {
				this.journeyId = this.$route.params.journeyId
				this.pageType = 'edit'
				this.branchId = this.$route.params.branchId
				this.getJourneyDetails()
			} else if (this.$route.params.type == 'view') {
				this.journeyId = this.$route.params.journeyId
				this.pageType = 'view'
				this.branchId = this.$route.params.branchId
				this.getJourneyDetails()
			} else {
				this.journeyId = 0
			}
		},
		methods: {
			addRoles() {},
			addFaqFormData() {
				this.faqFields.push({
					question: "",
					answer: "",
				})
			},
			// getCorporateBranchList: function() {
			// 	this.isReportTableBusy = true,
			// 	this.$api.post('corporate/get-branch', {
			// 		corporateId: (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId,
			// 		}).then((result) => {
			// 		this.branches = result.data.data
			// 		//this.branchId = result.data.data[0]._id
			// 		//console.log(this.branchId)
			// 		if (this.$route.params.type == 'edit') {
			// 			this.journeyId = this.$route.params.journeyId
			// 			this.pageType = 'edit'
			// 			this.branchId = this.$route.params.branchId
			// 			this.getJourneyDetails()
			// 		} else if (this.$route.params.type == 'view') {
			// 			this.journeyId = this.$route.params.journeyId
			// 			this.pageType = 'view'
			// 			this.branchId = this.$route.params.branchId
			// 			this.getJourneyDetails()
			// 		} else {
			// 			this.journeyId = 0
			// 		}
			// 	}).catch((error) => {
			// 		alert(error)
			// 	})
			// },
			addRulesFormData() {
				this.rulesFields.push({
					triggerTime: 'hh:mm A',
					materials: {
						materialLink: '',
						materialInputText: '',
					},
					questions: [
						{
							id: 1,
							questionText: ''
						},
					],
				})
			},
			addDocumentFormData() {
				this.documentFields.push({
					name: null,
					isVerificationRequired: false,
					isESignRequired: true,
				})
			},
			addMoreQuestion: function(index, id) {
				this.rulesFields[index].questions.push({
					id: id + 1,
					questionText: '',
				})
			},
			addFeebackQuestion: function(index, id) {
				this.rulesFields[index].questions.push({
					id: id + 1,
					questionText: '',
				})
			},
			deleteFeedbackQuestion: function(index, id) {
				this.rulesFields[index].questions.splice(id, 1)
			},
			deleteQuestionRow: function(index, id) {
				this.rulesFields[index].questions.splice(id, 1)
			},
			/**
			 * Delete the row
			 */
			deleteFaqRow(index) {
				if (confirm("Are you sure you want to delete this element?"))
					this.faqFields.splice(index, 1)
			},
			deleteRulesRow(index) {
				if (confirm("Are you sure you want to delete this element?"))
					this.rulesFields.splice(index, 1)
			},
			deleteDocumentRow(index) {
				if (confirm("Are you sure you want to delete this element?"))
					this.documentFields.splice(index, 1)
			},
			handleFaqFileUpload(event) {
				this.file = event.target.files[0]
				let formData = new FormData()
				formData.append('file', this.file)
				//formData.append('corpBranchID', 1) //TODO change this to dynamic
				this.$api.post('onboarding-journey/upload-excel', //TODO change this url
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				).then((response) => {
					//this.faqFields = response.data.data
					this.faqFields = []
					for (let i = 0;i < response.data.data.length;i++) {
						let question = response.data.data[i].Question
						this.faqFields.push({
							question: question,
						})
					}
				})
			},
			handleFileUpload: function(event, index) {
				this.file = event.target.files[0]
				let formData = new FormData()
				formData.append('file', this.file)
				this.$api.post('onboarding-journey/upload-excel', formData, {
					header: {
						'Content-Type': 'multipart/form-data',
					},
				}).then((response) => {
					this.rulesFields[index].questions = []
					for (let i = 0;i < response.data.data.length;i++) {
						let question = response.data.data[i].Question
						this.rulesFields[index].questions.push({
							questionText: question,
						})
					}
				})
			},
			handleFeedbackUpload: function(event, index) {
				this.file = event.target.files[0]
				let formData = new FormData()
				formData.append('file', this.file)
				this.$api.post('onboarding-journey/upload-excel', formData, {
					header: {
						'Content-Type': 'multipart/form-data',
					},
				}).then((response) => {
					this.rulesFields[index].questions = []
					for (let i = 0;i < response.data.data.length;i++) {
						let question = response.data.data[i].Question
						this.rulesFields[index].questions.push({
							id: (i + 1),
							questionText: question,
						})
					}
				})
			},
			uploadMaterial: function(event, index) {
				this.file = event.target.files[0]
				let formData = new FormData()
				formData.append('material', this.file)
				this.$api.post('onboarding-journey/upload-material', formData, {
					header: {
						'Content-Type': 'multipart/form-data',
					},
				}).then((response) => {
					console.log(response)
					if (response.data.responseCode == 200) {
						this.rulesFields[index].materials.materialLink = response.data.data.url
					}
					if (response.data.responseCode == 400) {
						this.$toast.error(response.data.response, {
							position: "top-right",
							timeout: 5000,
							closeOnClick: true,
							pauseOnFocusLoss: true,
							pauseOnHover: true,
							draggable: true,
							draggablePercent: 0.6,
							showCloseButtonOnHover: false,
							hideProgressBar: false,
							closeButton: "button",
							icon: true,
							rtl: false
						})
					}
				}).catch((error) => {
					console.error("Line 369 -> Error: " + error)
					this.$toast.error("Invalid file type: Please upload a valid file type (JPEG, PNG, PDF, Excel, CSV).", {
						position: "top-right",
						timeout: 5000,
						closeOnClick: true,
						pauseOnFocusLoss: true,
						pauseOnHover: true,
						draggable: true,
						draggablePercent: 0.6,
						showCloseButtonOnHover: false,
						hideProgressBar: false,
						closeButton: "button",
						icon: true,
						rtl: false
					})
				})
			},
			addNewDocumentType(newDoc) {
				this.docOptions.push(newDoc)
				this.document = newDoc
				// this.docOptions.at(index).Doc
			},
			addDayOptions: function(newDay) {
				this.dayOptions.push(newDay)
			},
			addTriggerOptions: function(newTriggerOption) {
				this.triggerOptions.push(newTriggerOption)
			},
			addActionOptions: function(newActionOption) {
				this.actionOptions.push(newActionOption)
			},
			// Stepper form submit at every step
			onNextStep: function (tabIndex) {
				let corporateId = (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId
				let branchId = (this.branchId !== undefined && this.branchId !== null) ? this.branchId : this.$storageData.branchId
				return new Promise((resolve, reject) => {
					if (tabIndex === 0) {
						if (this.pageType == 'edit') {
							this.$api.post('onboarding-journey/edit-roles', {
								onboardJourneyId: this.journeyId,
								corporateId: corporateId,
								branchId: branchId,
								journeyName: this.journeyName,
								//designation: this.jobRoles,
							}).then((result) => {
								let status = result.data.responseCode
								if (status === 200) {
									this.journeyId = result.data.data.onboardJourneyDetail._id
									//this.$v.reset()
									resolve(true)
								}
								if (status === 400) {
									//alert(result.data.response)
									//this.isJourneyNameExists = true
									this.$toast.error(result.data.response, {
										position: "top-right",
										timeout: 5000,
										closeOnClick: true,
										pauseOnFocusLoss: true,
										pauseOnHover: true,
										draggable: true,
										draggablePercent: 0.6,
										showCloseButtonOnHover: false,
										hideProgressBar: false,
										closeButton: "button",
										icon: true,
										rtl: false
									})
									reject(false)
								}
							}).catch((error) => {
								alert("You don't have permissions to view this pages")
								console.log(error)
								reject(false)
							})
						} else if(this.pageType == 'view') {
							resolve(true)
						} else {
							this.$api.post('onboarding-journey/add-rules', {
								journeyName: this.journeyName,
								//designation: this.jobRoles,
								corporateId: corporateId,
								branchId: branchId,
							}).then((result) => {
								let status = result.data.responseCode
								if (status == 200) {
									this.journeyId = result.data.data.onboardJourneyDetail._id
									//this.$v.reset()
									resolve(true)
								}
								if (status === 400) {
									//alert(result.data.response)
									//this.isJourneyNameExists = true
									this.$toast.error(result.data.response, {
										position: "top-right",
										timeout: 5000,
										closeOnClick: true,
										pauseOnFocusLoss: true,
										pauseOnHover: true,
										draggable: true,
										draggablePercent: 0.6,
										showCloseButtonOnHover: false,
										hideProgressBar: false,
										closeButton: "button",
										icon: true,
										rtl: false
									})
									reject(false)
								}
							}).catch((error) => {
								alert("You don't have permissions to view this pages")
								console.log(error)
								reject(false)
							})
						}
					}
					if (tabIndex === 1) {
						let checklist = []
						this.documentFields.forEach(field => {
							if (field.name !== '' && field.name !== null) {
								checklist.push({
									name: field.name,
									isVerificationRequired: field.isVerificationRequired,
									isESignRequired: field.isESignRequired
								})
							}
						})
						// //reject(false)
						// this.$v.documentFields.$each.name.touch()
						// if (this.$v.documentFields.$each.name.$invalid) {
						// 	reject(false)
						// }
						if (this.$v.isOneDocumentSelected) {
							this.$api.post('onboarding-journey/add-document-checklist', {
								onboardJourneyId: this.journeyId,
								documentChecklist: checklist
							}).then((result) => {
								let status = result.data.responseCode
								if (status === 200) {
									resolve(true)
								}
								if (status === 400) {
									this.$toast.error(result.data.response, {
										position: "top-right",
										timeout: 5000,
										closeOnClick: true,
										pauseOnFocusLoss: true,
										pauseOnHover: true,
										draggable: true,
										draggablePercent: 0.6,
										showCloseButtonOnHover: false,
										hideProgressBar: false,
										closeButton: "button",
										icon: true,
										rtl: false
									})
									reject(false)
								}
							}).catch((error) => {
								alert("You don't have permissions to view this pages")
								console.log(error)
								reject(false)
							})
						} else {
							reject(false)
						}
					}
					if (tabIndex === 2) {
						this.$api.post('onboarding-journey/add-roles-rules', {
							onboardJourneyId: this.journeyId,
							adminId: this.$storageData.id,
							corporateId: corporateId,
							branchId: branchId,
							rule: this.rulesFields,
						}).then((result) => {
							let status = result.data.responseCode
							if (status === 200) {
								this.$router.push('/onboarding/journey-lists')
								resolve(true)
							} 
							if (status === 400) {
								reject(false)
							}
						}).catch((error) => {
							alert("You don't have permissions to view this pages")
							console.error(error)
							reject(false)
						})
					}
				})
			},
			filterDataByRange: function(which, text) {
				if (text === 'Yes') {
					this.documentFields[which].isVerificationRequired = true
					this.documentFields[which].isESignRequired = true
				}
				if (text === 'No') {
					this.documentFields[which].isVerificationRequired = false
					this.documentFields[which].isESignRequired = false
				}
			},
			actionChange: function(index) {
				this.showModal = true
				if (this.rulesFields[index].action === 'Collect Information') {
					this.$bvModal.show('collect-info' + (index))
				}
				if (this.rulesFields[index].action === 'Collect Feedback') {
					this.$bvModal.show('collect-feedback' + (index))
				}
			},
			closeModal: function(index) {
				this.showModal = false
				this.$bvModal.hide('collect-info' + (index))
				this.$bvModal.hide('collect-feedback' + (index))
				this.resetQuestions(index)
			},
			getJourneyDetails: function() {
				let corporateId = (this.corporateId !== undefined && this.corporateId !== null) ? this.corporateId : this.$storageData.corporateId
				let branchId = (this.branchId !== undefined && this.branchId !== null) ? this.branchId : this.$storageData.branchId
				this.$api.post('onboarding-journey/details', {
					onboardJourneyId: this.journeyId,
					corporateId: corporateId,
					branchId: branchId,
				}).then((result) => {
					this.onboardJourneyDetail = result.data.data.onboardJourneyDetail
					this.journeyName = this.onboardJourneyDetail.journeyName
					this.jobRoles = this.onboardJourneyDetail.designation
					this.documentFields = this.onboardJourneyDetail.documentChecklist
					this.rulesFields = this.onboardJourneyDetail.rule
				}).catch((error) => {
					console.log(error)
				})
			},
			validateQuestionText: function(fieldIndex, questionIndex) {
				const validPattern = /^[a-zA-Z0-9 ?!.,-]+$/
				const question = this.rulesFields[fieldIndex].questions[questionIndex]
				
				if (!question.questionText.trim()) {
					question.questionError = 'Enter a question'
				} else if (!validPattern.test(question.questionText)) {
					question.questionError = 'Enter a valid question'
				} else {
					question.questionError = ''
				}
			},
			resetQuestions: function (index) {
				this.rulesFields[index].questions = [
					{
						id: 1,
						questionText: '',
						questionError: '',
					},
				]
			}
		},
		middleware: "authentication",
	}
</script>
<style scoped>
	.page-content {
		min-height: 750px;
	}
	.modal-body{
		overflow: hidden;
		overflow-y: auto;
		max-height: 450px;
	}
	.float-left {
		float: left;
	}
	.float-right {
		float: right;
	}
	.modal-footer {
		justify-content: space-between;
	}
	.is-invalid {
		border-color: #f46a6a;
	}
	input.form-control, input.form-control:hover, input.form-control:focus {
		outline: 0 none;
		box-shadow: 0 none;
	}
	.vue__time-picker {
		width: 100%;
	}
	.vue__time-picker input.display-time {
		width: 100%;
		height: auto;
		padding: 0.47rem 0.75rem;
		font-size: 0.88rem;
		font-weight: 400;
		line-height: 1.5;
		color: #495057;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #ced4da;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border-radius: 0.25rem;
		transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	}
	.vue__time-picker input.display-time:focus,
	.vue__time-picker input.display-time:active {
		border: 1px solid #ced4da;
		outline: none;
		box-shadow: none;
	}
	.vue__time-picker-dropdown,
	.vue__time-picker .dropdown {
		top: auto;
	}
	.vue__time-picker-dropdown,
	.vue__time-picker .dropdown,
	.vue__time-picker-dropdown .select-list,
	.vue__time-picker .dropdown .select-list {
		width: 100%;
	}
	.vue__time-picker input.display-time.disabled,
	.vue__time-picker input.display-time:disabled {
		background: #ededed;
	}
	.timing.set-all span,
	.timing.set-all div.col-md-3 {
		display: inline-block;
	}
	.btn, .btn:hover, .btn:active, .btn:focus {
		background-color: transparent;
		color: #EB455F;
		outline: none;
		box-shadow: none;
	}
	.btn.active, .btn.active:hover, .btn.active:active, .btn.active:focus {
		background-color: #EB455F;
		color: #ffffff;
		outline: none;
		box-shadow: none;
	}
	.check-group .btn {
		margin: 0;
	}
</style>
<template>
	<Layout>
		<PageHeader :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title"></h4>
						<form-wizard color="#EB455F">
							<!-- Journey Template Form START -->
							<tab-content :before-change="() => onNextStep(0)">
								<div class="row">
									<h4>Add Roles</h4>
									<div class="col-lg-12 align-self-center">
										<div class="form-group mb-4">
											<label class="col-md-3 col-form-label" for="journeyName">Journey Name*</label>
											<div class="col-md-6">
												<div class="mb-3">
													<input
														id="journeyName"
														v-model="journeyName"
														type="text"
														class="form-control"
														name="journeyName"
														@input="$v.journeyName.$touch()"
														:class="{ 'is-invalid': $v.journeyName.$error || isJourneyNameExists }"
														value="Common Template"
														:disabled="pageType == 'view' ? true : false" />
													<div v-if="$v.journeyName.$error || isJourneyNameExists" class="invalid-feedback">
														<div v-if="!$v.journeyName.required">Journey name is required.</div>
														<div v-if="!$v.journeyName.noInvalidStrings">Journey name is invalid.</div>
														<div v-if="isJourneyNameExists">Journey name already exist</div>
													</div>
												</div>
											</div>
										</div>
										<!-- <label class="col-md-3 col-form-label" for="jobRoles">Which designation is this journey for?</label>
										<div class="col-md-6">
											<div class="mb-3">
												<multiselect
													id="jobRoles"
													class=""
													name="jobRoles"
													v-model="jobRoles"
													:options="jobOptions"
													:multiple="true"
													:allow-empty="false"
													:disabled="pageType == 'view' ? true : false"
													:class="{ 'is-invalid': $v.jobRoles.$error }"></multiselect>
											</div>
										</div> -->
									</div>
									<!-- end col -->
								</div>
								<!-- end row -->
							</tab-content>
							<!-- Journey Template Form END -->
							<!-- Document Checklist START -->
							<tab-content :before-change="() => onNextStep(1)">
								<div class="row">
									<h4>Add Document Checklist</h4>
									<div class="col-lg-12">
										<!-- <label class="col-md-3 col-form-label" for="userName">Documents*</label> -->
										<form class="repeater" enctype="multipart/form-data">
											<div v-for="(field, index) in documentFields" :key="field.id" class="row" :class="{ 'is-invalid': !$v.isOneDocumentSelected.$model }">
												<div class="mb-3 col-lg-3">
													<label for="name">Document</label>
													<multiselect
														v-model="field.name"
														:options="docOptions"
														class="helo"
														:show-labels="false"
														:taggable="true"
														@tag="addNewDocumentType"
														:multiple="false"
														:class="{ 'is-invalid': $v.documentFields.$each[index].name.$error }"
														:disabled="pageType == 'view' ? true : false" />
													<div v-if="$v.documentFields.$each[index].name.$error" class="invalid-feedback">
														<div v-if="$v.documentFields.$each[index].name.required">Select Document.</div>
													</div>
												</div>
												<div class="mb-3 col-lg-2">
													<label v-if="field.name == 'Offer Letter'">E-sign Required?</label>
													<label v-else>Verification Required?</label>
													<div class="check-group btn-group-toggle btn-group bv-no-focus-ring" style="height:auto;" role="group" aria-label="Date options">
														<button type="button" class="btn btn-outline-danger" :class="`${field.isVerificationRequired ? 'active' : ''}`" v-on:click="filterDataByRange(index, 'Yes')" :disabled="pageType == 'view' ? true : false">Yes</button>
														<button type="button" class="btn btn-outline-danger" :class="`${!field.isVerificationRequired ? 'active' : ''}`" v-on:click="filterDataByRange(index, 'No')" :disabled="pageType == 'view' ? true : false">No</button>
													</div>
												</div>
												<div class="col-lg-1 align-self-center">
													<button type="button" class="btn btn-danger btn-block" value="Delete" @click="deleteDocumentRow(index)" :disabled="pageType == 'view' ? true : false">
														<i class="mdi mdi-delete-outline"></i>
													</button>
												</div>
											</div>
											<div v-if="!$v.isOneDocumentSelected.$model" class="invalid-feedback">
												<div>Atleast select one document.</div>
											</div>
											<input type="button" class="btn btn-danger mt-3 mt-lg-0" value="Add New Document" @click="addDocumentFormData" :disabled="pageType == 'view' ? true : false" />
										</form>
									</div>
									<!-- end col -->
								</div>
								<!-- end row -->
							</tab-content>
							<!-- Document Checklist Form END -->
							<!-- Rules START -->
							<tab-content :before-change="() => onNextStep(2)">
								<div class="row">
									<h4>Add Rules</h4>
									<div class="col-lg-12">
										<!-- <label class="col-md-3 col-form-label" for="userName">Documents*</label> -->
										<form class="repeater" enctype="multipart/form-data">
											<div v-for="(field, index) in rulesFields" :key="field.id" class="row">
												<div class="mb-3 col-lg-2">
													<label for="name">Days</label>
													<multiselect
														v-model="field.day"
														:options="dayOptions"
														class="helo"
														:taggable="true"
														@tag="addDayOptions"
														:show-labels="false"
														:disabled="pageType == 'view' ? true : false" />
												</div>
												<div class="mb-3 col-lg-2">
													<label for="name">Trigger</label>
													<multiselect
														v-model="field.trigger"
														:options="triggerOptions"
														:taggable="true"
														@tag="addTriggerOptions"
														class="helo"
														:show-labels="false"
														:disabled="pageType == 'view' ? true : false" />
												</div>
												<div class="mb-3 col-lg-2">
													<label for="name">Trigger Time</label>
													<vue-timepicker
														v-model="field.triggerTime"
														class="helo"
														format="hh:mm A"
														hour-label="Hour"
														minute-label="Miniutes"
														apm-label="AM/PM"
														close-on-complete
														hide-clear-button
														:class="{ 'is-invalid': field.isTriggerTimeError }"
														drop-direction="auto" />
													<div v-if="field.isTriggerTimeError" class="invalid-feedback">
														<div v-if="field.triggerTime === 'hh:mm A'">Select trigger time.</div>
													</div>
												</div>
												<div class="mb-3 col-lg-2">
													<label for="name">Action</label>
													<multiselect
														v-model="field.action"
														:options="actionOptions"
														:taggable="true"
														@tag="addActionOptions"
														class="helo"
														:show-labels="false"
														:disabled="pageType == 'view' ? true : false" />
												</div>
												<div class="mb-3 col-lg-2" v-if="field.action === 'Send Material'">
													<label for="resume">Attach Material</label>
													<input
														id="resume"
														type="file"
														@change="uploadMaterial($event, index)"
														class="form-control-file"
														accept="image/*,video/*,.pdf"
														:class="{ 'is-invalid': field.isMaterialsError }"
														:disabled="pageType == 'view' ? true : false" />
													<div v-if="field.isMaterialsError" class="invalid-feedback">Attach Material</div>
													<div v-if="pageType == 'view'"></div>
												</div>
												<div class="mb-3 col-lg-2" v-if="field.action === 'Send Material'">
													<label for="message">Text Input(Optional)</label>
													<textarea id="message" v-model="field.materials.materialInputText" class="form-control"></textarea>
												</div>
												<div class="md-3 col-lg-2 align-self-center" v-if="field.action === 'Collect Information'">
													<button type="button" class="btn btn-danger btn-block" value="Collect Inofrmation" @click="actionChange(index)">Collect Information</button>
												</div>
												<div class="md-3 col-lg-2 align-self-center" v-if="field.action === 'Collect Feedback'">
													<button type="button" class="btn btn-danger btn-block" value="Collect Feedback" @click="actionChange(index)">Collect Feedback</button>
												</div>
												<div class="col-lg-1 align-self-center">
													<button type="button" class="btn btn-danger btn-block" value="Delete" @click="deleteRulesRow(index)" :disabled="pageType == 'view' ? true : false">
														<i class="mdi mdi-delete-outline"></i>
													</button>
												</div>
												<b-modal v-bind:id="'collect-feedback' + (index)" class="modal fade" ref="feedbackModal" @hidden="resetQuestions(index)">
													<template #modal-title>Collect Feedback</template>
													<div class="modal-body" ref="modalBody">
														<div class="d-flex flex-column">
															<div class="mb-3 col-lg-12">
																<label for="feedback">Browse File</label>
																<input type="file" id="feedback" class="form-control-file" @change="handleFeedbackUpload($event, index)" />
																<br />
																<a href="">Download Sample</a>
															</div>
															<h4 class="text-center">OR</h4>
															<div v-for="(question, ind) in field.questions" :key="question.id" class="mb-3 d-flex col-md-12">
																<div class="col-lg-12">
																	<label v-bind:for="'feedback' + (ind + 1)" class="col-md-12 col-form-label">Question {{ ind + 1}}</label>
																	<div class="d-flex flex-row justify-content-between">
																		<div class="col-md-10">
																			<input
																				type="text"
																				:id="'feedback' + (ind + 1)"
																				v-model="question.questionText"
																				@input="validateQuestionText(index, ind)"
																				:class="{ 'is-invalid' : question.questionError }"
																				class="form-control"
																				:disabled="pageType == 'view' ? true : false" />
																			<div v-if="question.questionError" class="invalid-feedback">{{ question.questionError }}</div>
																		</div>
																		<div class="col-md-1">
																			<button class="btn btn-danger btn-block" value="Delete" @click="deleteFeedbackQuestion(index, (questions.id - 1))" :disabled="pageType == 'view' ? true : false">
																				<i class="mdi mdi-delete-outline"></i>
																			</button>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<template #modal-footer>
														<button type="button" class="btn btn-danger" @click="addFeebackQuestion(index, field.feedback.length)" :disabled="pageType == 'view' ? true : false"><i class="mdi mdi-plus mr-1"></i> Add more question</button>
														<button type="button" class="btn btn-danger" @click="() => closeModal(index)">Submit</button>
													</template>
												</b-modal>
												<b-modal v-bind:id="'collect-info' + (index)" class="modal fade" ref="collectInfoModal" @hidden="resetQuestions(index)">
													<template #modal-title>Collect Information</template>
													<div class="modal-body" ref="modalBody">
														<div class="row">
															<div class="mb-3 col-lg-12">
																<label for="resume">Browse File</label>
																<input id="resume" type="file" class="form-control-file" @change="handleFileUpload($event, index)" />
																<br />
																<a href="localhost:8000/">Download Sample</a>
															</div>
															<h4 class="text-center">OR</h4>
															<div v-for="(question, ind) in field.questions" :key="question.id" class="row">
																<div class="mb-3 col-lg-12 row">
																	<label v-bind:for="'question' + (ind + 1)" class="col-md-12 col-form-label">Question {{ind + 1}}</label>
																	<div class="col-md-11">
																		<input
																			type="text"
																			:id="'question' + (ind + 1)"
																			class="form-control"
																			v-model="question.questionText"
																			@input="validateQuestionText(index, ind)"
																			:class="{ 'is-invalid' : question.questionError }"
																			:disabled="pageType == 'view' ? true : false" />
																		<div v-if="question.questionError" class="invalid-feedback">{{ question.questionError }}</div>
																	</div>
																	<div class="col-md-1">
																		<button type="button" class="btn btn-danger btn-block" value="Delete" @click="deleteQuestionRow(index, ind)" :disabled="pageType == 'view' ? true : false">
																			<i class="mdi mdi-delete-outline"></i>
																		</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<template #modal-footer>
														<button class="btn btn-danger float-left" @click="() => addMoreQuestion(index, field.questions.length)" :disabled="pageType == 'view' ? true : false"><i class="mdi mdi-plus mr-1"></i>  Add more question</button>
														<button type="button" class="btn btn-danger float-right" @click="() => closeModal(index)">Submit</button>
													</template>
												</b-modal>
											</div>
											<!-- <input type="button" class="btn btn-success mt-3 mt-lg-0" value="Add New Document"  /> -->
											<b-button class="btn btn-soft-danger btn-danger" variant="danger" @click="addRulesFormData" :disabled="pageType == 'view' ? true : false">Add New <i class="uil uil-arrow-right ms-2"></i></b-button>
										</form>
									</div>
									<!-- end col -->
								</div>
								<!-- end row -->
							</tab-content>
							<!-- Rules Form END -->
						</form-wizard>
					</div>
					<!-- end card-body -->
				</div>
				<!-- end card -->
			</div>
			<!-- end col -->
		</div>
		<!-- end row -->
	</Layout>
</template>